type PromiseStatus = 'pending' | 'fulfilled' | 'rejected';

class DeferredPromise<T> {
  promise: Promise<T>;
  resolve!: (value: T | PromiseLike<T>) => void;
  reject!: (reason?: any) => void;
  status: PromiseStatus = 'pending'; // 初始状态为 pending

  constructor() {
    this.promise = new Promise<T>((resolve, reject) => {
      this.resolve = (value) => {
        if (this.status === 'pending') {
          this.status = 'fulfilled'; // 状态更新为 fulfilled
          resolve(value);
        }
      };

      this.reject = (reason) => {
        if (this.status === 'pending') {
          this.status = 'rejected'; // 状态更新为 rejected
          reject(reason);
        }
      };
    });
  }
}

export default DeferredPromise;
